import secondaryComponents from "../..";
import { useBulkProductUploadForm } from "./useBulkProductUploadForm";
import styles from "./styles.module.scss";
import primaryComponents from "../../../primaryComponents";

export const BulkProductUploadForm = ({ formData = [] }) => {
  const {
    instance,
    isCreatingProduct,
    handleBulkCreation,
    handleSubmit,
    addRow,
  } = useBulkProductUploadForm({
    formData,
  });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <div className={styles.bulkProductUploadForm}>
        <div className="d-flex pb-4" style={{ gap: "10px" }}>
          <primaryComponents.Button
            classNames={"btn btn--outline ml-auto"}
            isDisabled={isCreatingProduct}
            isLoading={isCreatingProduct}
            loadingText={"Uploading..."}
            onClick={() => addRow()}
          >
            Add New Product
          </primaryComponents.Button>
          <primaryComponents.Button
            classNames={"btn btn--primary"}
            isDisabled={isCreatingProduct}
            isLoading={isCreatingProduct}
            loadingText={"Uploading..."}
            onClick={handleSubmit(handleBulkCreation)}
          >
            Submit
          </primaryComponents.Button>
        </div>
        <secondaryComponents.TableHelper
          getTableProps={getTableProps}
          getTableBodyProps={getTableBodyProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
          hasAction={true}
        >
          <div className="text-center my-5">
            <h4 className="font-weight-semibold">No Data Available</h4>
          </div>
        </secondaryComponents.TableHelper>
      </div>
    </>
  );
};
